export const validationMessages = {
  $options: {
    validationMessages: {
      type: 'Błąd: Nieprawidłowa wartość.',
      number: 'Błąd: Wartość pola musi być liczbą.',
      money: 'Błąd: Wartość pola musi być liczbą.',
      integer: 'Błąd: Wartość pola musi być liczbą całkowitą.',
      required: 'Błąd: Wartość pola jest wymagana.',
      fieldRequired: 'Błąd: Wartość pola jest wymagana.',
      minimum: 'Błąd: Minimalna wartość to: {{minimum}}.',
      maximum: 'Błąd: Maksymalna wartość to: {{maximum}}.',
      exclusiveMinimum: 'Błąd: Wartość pola musi być większa niż {{exclusiveMinimum}}.',
      exclusiveMaximum: 'Błąd: Wartość pola musi być mniejsza niż {{exclusiveMaximum}}.',
      multipleOf: 'Błąd: Wartość musi być wielokrotnością {{multipleOf}}.',
      maxLength: 'Błąd: Tekst jest zbyt długi, maksymalnie {{maxLength}} znaków.',
      minLength: 'Błąd: Tekst jest zbyt krótki, minimalnie {{minLength}} znaków.',
      maxItems: 'Błąd: Zbyt dużo elementów, maksymalna ilość to: {{maxItems}}.',
      minItems: 'Błąd: Za mało elementów, minimalna ilość to: {{minItems}}.',
      enum: 'Błąd: Nieprawidłowa wartość.',
      format: 'Błąd: Nieprawidłowy format.',
      pattern: 'Błąd: Nieprawidłowy format.',
      'format.nip': 'Błąd: Nieprawidłowy format, NIP musi składać się z dziesięciu cyfr.',
      'format.email': 'Błąd: Nieprawidłowy format, adres e-mail musi być wprowadzony w formacie nazwa@domena.',
      'format.kod':
        'Błąd: Nieprawidłowy format, kod pocztowy musi być wprowadzony w formacie xx-xxx i składać się z samych cyfr.'
    },
    warningMessages: {
      type: 'Błąd: Nieprawidłowa wartość.',
      number: 'Błąd: Wartość pola musi być liczbą.',
      money: 'Błąd: Wartość pola musi być liczbą.',
      integer: 'Błąd: Wartość pola musi być liczbą całkowitą.',
      required: 'Błąd: Wartość pola jest wymagana.',
      fieldRequired: 'Błąd: Wartość pola jest wymagana.',
      minimum: 'Błąd: Minimalna wartość to: {{minimum}}.',
      maximum: 'Błąd: Maksymalna wartość to: {{maximum}}.',
      exclusiveMinimum: 'Błąd: Wartość pola musi być większa niż {{exclusiveMinimum}}.',
      exclusiveMaximum: 'Błąd: Wartość pola musi być mniejsza niż {{exclusiveMaximum}}.',
      multipleOf: 'Błąd: Wartość musi być wielokrotnością {{multipleOf}}.',
      maxLength: 'Błąd: Tekst jest zbyt długi, maksymalnie {{maxLength}} znaków.',
      minLength: 'Błąd: Tekst jest zbyt krótki, minimalnie {{minLength}} znaków.',
      maxItems: 'Błąd: Zbyt dużo elementów, maksymalna ilość to: {{maxItems}}.',
      minItems: 'Błąd: Za mało elementów, minimalna ilość to: {{minItems}}.',
      enum: 'Błąd: Nieprawidłowa wartość.',
      format: 'Błąd: Nieprawidłowy format.',
      pattern: 'Błąd: Nieprawidłowy format.',
      'format.nip': 'Błąd: Nieprawidłowy format, NIP musi składać się z dziesięciu cyfr.',
      'format.email': 'Błąd: Nieprawidłowy format, adres e-mail musi być wprowadzony w formacie nazwa@domena.',
      'format.kod':
        'Błąd: Nieprawidłowy format, kod pocztowy musi być wprowadzony w formacie xx-xxx i składać się z samych cyfr.'
    }
  }
};
